<!--
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-08-02 10:16:52
 * @LastEditors: dudedu
 * @LastEditTime: 2022-10-28 16:44:06
-->
<template>
<div>FAQ</div>
</template>

<script>
export default {
  name: 'helpCenterFAQ',
};
</script>

<style scoped>

</style>
